import React, { useEffect, useState } from "react";
import styles from "./EdlStyles.module.css";
import { Alert, Button, Card,  Space, Typography,  } from 'antd';
import { IconCopy, IconEdit,} from "../../icons";
import Dot from "../UI/Dot";
import ModalChangePassword from "./ModalChangePassword";
import { useDispatch, useSelector } from "react-redux";
import { getEdlCheckErrors, getEdlDataLists, getEdlDataUser, getEdlLoaders,  getEdlWarningPlatform,  } from "../../store/edl/selectors";

const { Title, Text, Link } = Typography;
const styleColorGray = { color: "#989AA5" };

function EdlSettingsNew() {

	const isLoading = useSelector(getEdlLoaders);
	const [modalChangePasswordOpen, setModalChangePasswordOpen] = useState(false);

	const dataUser = useSelector(getEdlDataUser);
	const [copyText, setCopyText] = useState(false)

	const dateEndStatus = (date, status) => {

		if (status?.includes('дн') && (Number(status.split(' ')[0]) === 0)) return <span style={{ marginRight: 10, fontSize: '14px', color: 'red' }} >{date} ({status})</span>;
		else if (status?.includes('дн') && (Number(status.split(' ')[0]) <= 31)) return <span style={{ marginRight: 10, fontSize: '14px', color: '#E39800' }} >{date} ({status})</span>;
		else return <span style={{ marginRight: 10, fontSize: '14px', color: '#219653' }} >{date} ({status})</span>
	}

	const copyBufferText = (text, field) => {
		navigator.clipboard.writeText(text)
			.then((res) => {

				setCopyText({ text: 'Copy', field: field })
			})
			.catch(err => {
				setCopyText({ text: 'Error', field: field });
			});
	}

	return (
		<>
			{modalChangePasswordOpen &&<ModalChangePassword open={modalChangePasswordOpen} close={() => setModalChangePasswordOpen(false)} />}
			<Card>
				<Space style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
					<Title level={4}>Http-авторизация устройств</Title>
					<Button
						onClick={() => setModalChangePasswordOpen(true)}
						icon={<IconEdit />}
					>
						Изменить
					</Button>
				</Space>
				<div className={styles.httpDevices}>
					<Text>Домен</Text>
					<Text>{dataUser?.domain}</Text>
					<Text>Логин</Text>
					<Space size={12}><Text>{dataUser?.device_username}</Text><Button size="small" type="text" onClick={() => copyBufferText(dataUser?.device_username, 'login')} icon={<IconCopy style={{ color: "#8090B8" }} />} />
						<span style={copyText.text === 'Error' ? { color: "red" } : { color: "green" }}>{copyText.field === 'login' ? copyText.text : ''}</span>
					</Space>
					<Text>Доступ до</Text>
					<Space size={12}>
						<Text>{dataUser?.is_trial? <span style={{color: '#219653'}}>TRIAL</span> : dateEndStatus(dataUser?.date_end, dataUser?.time_left_verbose)}</Text>
						{/* <Text style={styleColorGray}>{dataUser?.time_left_verbose}</Text> */}
					</Space>

					<Text>Пароль</Text>
					<Space size={12}>

						<Text>{dataUser?.device_password}</Text><Button size="small" type="text" onClick={() => copyBufferText(dataUser?.device_password, 'password')} icon={<IconCopy style={{ color: "#8090B8" }} />} />
						<span style={copyText.text === 'Error' ? { color: "red" } : { color: "green" }}>{copyText.field === 'password' ? copyText.text : ''}</span>
					</Space>
				</div>
			</Card>

		</>

	)
}


export default EdlSettingsNew;
